/**
 * 下载 / 唤端路由
 * 根据运行期配置与设备类型，决定跳往 App Store / 应用市场 / 直接下载 APK，
 * 以及通过 URL Scheme 唤起 App（可直达 App 内指定页面）。
 */
import { getRuntimeConfig } from "@/shared/config/env"

import { isIOS } from "./ua"

/** APK 直链（Android / 桌面）；未配置 apk 时回退到 android 链接 */
export function getApkUrl(): string {
  const { download } = getRuntimeConfig()
  return download.apk || download.android
}

/** App Store 链接（iOS）。当前 iOS 未上架，页面侧先 mock，不做跳转 */
export function getIosUrl(): string {
  return getRuntimeConfig().download.ios
}

/** 按设备自动选择下载链接 */
export function getDownloadUrl(): string {
  return isIOS() ? getIosUrl() : getApkUrl()
}

export function downloadApp(): void {
  window.location.href = getDownloadUrl()
}

/** 直接下载 APK（不区分设备，供「下载应用」按钮使用） */
export function downloadApk(): void {
  window.location.href = getApkUrl()
}

export function buildAppLink(
  path: string,
  query: Record<string, string> = {},
): string {
  const scheme = getRuntimeConfig().appScheme
  const cleanPath = path.startsWith("/") ? path.slice(1) : path
  const qs = new URLSearchParams(query).toString()
  return qs ? `${scheme}${cleanPath}?${qs}` : `${scheme}${cleanPath}`
}

export interface OpenAppOptions {
  fallbackDownload?: boolean
  onFail?: () => void
  path?: string
  query?: Record<string, string>
}

export function openApp(options: OpenAppOptions = {}): void {
  const { fallbackDownload = true, onFail, path, query } = options
  const { appScheme } = getRuntimeConfig()

  const target = path ? buildAppLink(path, query) : appScheme

  if (!appScheme) {
    if (fallbackDownload) downloadApp()
    onFail?.()
    return
  }

  const needFallback = fallbackDownload || Boolean(onFail)

  if (needFallback) {
    let launched = false

    const markLaunched = () => {
      if (document.visibilityState === "hidden") launched = true
    }
    document.addEventListener("visibilitychange", markLaunched)

    window.setTimeout(() => {
      document.removeEventListener("visibilitychange", markLaunched)
      if (launched || document.visibilityState !== "visible") return
      if (fallbackDownload) downloadApp()
      onFail?.()
    }, 1500)
  }

  window.location.href = target
}

export function openAppPage(
  path: string,
  query: Record<string, string> = {},
  options: OpenAppOptions = {},
): void {
  openApp({ ...options, path, query })
}
